import { useState, useCallback, useRef, useEffect } from 'react';

/**
 * Copy text and expose which key was last copied, resetting after two
 * seconds — enough for a "Copied" flash on the button that was pressed.
 */
export const useCopyToClipboard = () => {
  const [copied, setCopied] = useState<string | null>(null);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  const copy = useCallback(async (text: string, key: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(key);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => setCopied(null), 2000);
    } catch (e) {
      console.error('Failed to copy', e);
    }
  }, []);

  return { copied, copy };
};
